exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ant-cascader-menu-item:hover {\n  background: #F5F7FA;\n}\n\n/* 修改日期选择器弹窗底部\"清空\"按钮文字为\"关闭\" */\n.el-picker-panel__footer .el-button--text:first-child {\n  font-size: 0 !important;\n}\n.el-picker-panel__footer .el-button--text:first-child::after {\n  content: '\\5173\\95ED';\n  font-size: 12px;\n}\n", ""]);

// exports
